import { Avatar, Box, FormControlLabel, Switch, Typography } from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import { GroupRow } from 'src/modules/admin/group-manager/gm_scopes'
import { Logger } from 'wdc-cube'
import { ProfileScope } from '../../gp_scopes'
import ProfileCard from './profile-card'

const LOG = Logger.get('GroupProfile')

export type GroupProfileProps = {
    className?: string
    style?: React.CSSProperties
    key?: string
    scope: ProfileScope
}

function GroupProfile({ scope, className, style }: GroupProfileProps) {
    const group = scope.profile || ({} as GroupRow)

    const onToggleBlockExport = (evt: React.ChangeEvent<HTMLInputElement>) => {
        scope.onToggleBlockExport(evt.target.checked).catch(LOG.caught)
    }

    return (
        <ProfileCard className={clsx(className)} style={style}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 4 }}>
                <Avatar sx={{ width: 64, height: 64, mr: 2 }}>{group.name?.[0]}</Avatar>
                <Box>
                    <Typography variant="h5">{group.name}</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                        <Typography variant="body1">
                            Franquia de exportação de dados contratada:{' '}
                            <strong>{group.unlimited_data_export ? 'ILIMITADA' : group.limit_export_quantity}</strong>
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                        <Typography variant="body1">
                            Usuário administrador do grupo:{' '}
                            <strong>
                                {group.admin_fullname || group.admin_name || 'Sem administrador cadastrado'}
                            </strong>
                        </Typography>
                    </Box>
                    {!group.unlimited_data_export && (
                        <Box sx={{ mt: 1 }}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={Boolean(group.block_export_when_exceeded)}
                                        disabled={scope.savingBlockExport}
                                        onChange={onToggleBlockExport}
                                        name="block_export_when_exceeded"
                                    />
                                }
                                label="Bloquear exportação de dados ao exceder a franquia contratada"
                                labelPlacement="end"
                            />
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'text.secondary'
                                }}
                            >
                                Quando ativado, exportações que ultrapassarem a franquia mensal do grupo serão
                                bloqueadas. Quando desativado, a exportação é permitida com aviso de cobrança adicional.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Box>
        </ProfileCard>
    )
}
export default GroupProfile
